import { useCallback, useState } from "react";
import { toast } from "sonner";

/** Web Speech API ile Türkçe dikte. */
export function useAkilSpeech(onTranscript) {
    const [listening, setListening] = useState(false);

    const start = useCallback(() => {
        const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SR) {
            toast.error("Tarayıcınız sesli komut / dikte desteklemiyor.");
            return;
        }
        const rec = new SR();
        rec.lang = "tr-TR";
        rec.interimResults = false;
        rec.maxAlternatives = 1;
        rec.onresult = (event) => {
            const text = event.results?.[0]?.[0]?.transcript;
            if (text) onTranscript?.(text.trim());
        };
        rec.onerror = () => toast.error("Ses tanıma hatası.");
        rec.onend = () => setListening(false);
        setListening(true);
        rec.start();
    }, [onTranscript]);

    return { listening, start };
}
